import { CreationRapide } from "@repo/ui/features/creation-rapide/index";

export default function CreationRapidePage() {
  return <CreationRapide />;
}
